import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  textClassName?: string;
}

const Logo: React.FC<LogoProps> = ({
  size = 'md',
  showText = true,
  className = '',
  textClassName = '',
}) => {
  const sizeClasses = {
    sm: 'h-6 w-auto',
    md: 'h-8 w-auto',
    lg: 'h-10 w-auto',
    xl: 'h-12 w-auto',
  };

  const textSizeClasses = {
    sm: 'text-lg font-semibold',
    md: 'text-xl font-semibold',
    lg: 'text-2xl font-semibold',
    xl: 'text-3xl font-semibold',
  };

  if (!showText) {
    return (
      <img
        src="/images/logo.png"
        alt="ImmStack Logo"
        className={`${sizeClasses[size]} ${className}`}
      />
    );
  }

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <img
        src="/images/logo.png"
        alt="ImmStack Logo"
        className={sizeClasses[size]}
      />
      <span
        className={`text-blue-600 ${textSizeClasses[size]} ${textClassName}`}
      >
        ImmStack
      </span>
    </div>
  );
};

export default Logo;
